<template>
  <v-layout>
    <GmapMap
      ref="myMap"
      :center="myCoordinates"
      :zoom="zoom"
      map-type-id="roadmap"
      style="width: 100%; height: 100%; position: absolute"
      :options="{
        gestureHandling: 'greedy',
        mapTypeControl: true,
        mapTypeControlOptions: {
          position: 3,
        },
      }"
    >
      <GmapMarker
        :key="index"
        v-for="(m, index) in markers"
        :position="m.position"
        :icon="markerOptions"
        :clickable="true"
        @click="toggleInfoWindow(m, index)"
      />
      <GmapInfoWindow
        :options="infoOptions"
        :position="infoWindowPos"
        :opened="infoWinOpen"
        @closeclick="infoWinOpen = false"
      >
        <div v-html="infoContent"></div>
      </GmapInfoWindow>
    </GmapMap>
    <div class="positionbtn">
      <v-menu
        v-if="true"
        v-model="menuProveedores"
        :close-on-content-click="false"
        :nudge-width="200"
        offset-x
        transition="scale-transition"
        z-index="1"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn fab v-bind="attrs" v-on="on">
            <v-icon v-if="!menuProveedores">fas fa-expand</v-icon>
            <v-icon v-else>fas fa-compress</v-icon>
          </v-btn>
        </template>
        <v-toolbar dense>
          <v-autocomplete
            hide-details
            v-model="search"
            :items="markers"
            item-text="name"
            item-value="key"
            single-line
            class="mx-5"
            @change="searchChanged()"
            clearable
            label="Proveedores activos"
          >
          </v-autocomplete>
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                color="green"
                v-bind="attrs"
                v-on="on"
                @click="initGeoFire()"
                ><v-icon class="fa fa-sync-alt"></v-icon
              ></v-btn>
            </template>
            <span>Recargar</span>
          </v-tooltip>
        </v-toolbar>
        <v-card
          max-height="500px"
          width="340px"
          target="onScroll"
          elevation="0"
          color="#0000"
        >
          <v-card-text class="pa-0">
            <div>
              <v-container>
                <v-row dense>
                  <v-col
                    cols="12"
                    v-for="(item, i) in markers"
                    :key="i"
                    class="pa-0"
                  >
                    <v-card outlined elevation="5" color="#4895ef">
                      <div class="d-flex flex-no-wrap justify-space-between">
                        <div>
                          <v-card-text
                            class="
                              pt-2
                              caption
                              pb-0
                              font-weight-bold
                              white--text
                            "
                            >{{ item.name }}</v-card-text
                          >
                          <v-card-text
                            class="
                              pt-0
                              pb-0
                              caption
                              font-weight-bold
                              white--text
                            "
                            >{{ item.plate }}</v-card-text
                          >
                          <v-card-actions>
                            <v-btn
                              @click="
                                flyMarker(
                                  item.position['lat'],
                                  item.position['lng']
                                )
                              "
                              outlined
                              rounded
                              small
                            >
                              VER
                            </v-btn>
                          </v-card-actions>
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </div>
          </v-card-text>
        </v-card>
      </v-menu>
    </div>
  </v-layout>
</template>

<script>
import { dbRefProveedor, geofireRef, geofireRefWorking } from "../main";

const mapMarker = require("../assets/marker_proveedor.png");

export default {
  data() {
    return {
      myCoordinates: {
        lat: 0,
        lng: 0,
      },
      zoom: 11,
      markers: [],
      markerAux: [],
      markerOptions: {
        url: mapMarker,
        size: { width: 43, height: 59, f: "px", b: "px" },
        scaledSize: { width: 43, height: 59, f: "px", b: "px" },
      },
      //variables para mensaje del marcador
      infoContent: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35,
        },
      },
      infoWindowPos: {
        lat: 0,
        lng: 0,
      },
      infoWinOpen: false,
      infoContent: "",
      currentMidx: null,
      imageDriver: "",
      nameDriver: null,
      namePlate: null,
      offsetTop: 0,
      search: "",
      keyAux: "",
      menuProveedores: false,
    };
  },
  created() {
    this.initGeoFire();
  },
  methods: {
    initGeoFire() {
      this.markers = [];
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
          var lat = position.coords.latitude;
          var lng = position.coords.longitude;
          this.myCoordinates = {
            lat: lat,
            lng: lng,
          };
          var query = geofireRef.query({
            center: [lat, lng],
            radius: 170,
          });
          var queryWorking = geofireRefWorking.query({
            center: [lat, lng],
            radius: 170,
          });

          query.on("key_entered", (key, location, distance) => {
            const dataName = dbRefProveedor.child(key);

            dataName.on("value", (snapshot) => {
              if (snapshot.val().image) {
                this.imageDriver = snapshot.val().image;
              } else {
                this.imageDriver = require("../assets/iconLogoName.png");
              }
              var nombre = snapshot.val().name;
              var placa = snapshot.val().vehiclePlate;
              this.nameDriver = nombre.toUpperCase();
              this.namePlate = placa.toUpperCase();
              this.markers.push({
                key: key,
                image: this.imageDriver,
                name: this.nameDriver,
                plate: this.namePlate,
                position: {
                  lat: location[0],
                  lng: location[1],
                },
              });
            });
          });
          queryWorking.on("key_entered", (key, location, distance) => {
            const dataName = dbRefProveedor.child(key);

            dataName.on("value", (snapshot) => {
              if (snapshot.val().image) {
                this.imageDriver = snapshot.val().image;
              } else {
                this.imageDriver = require("../assets/logoAR.png");
              }
              var nombre = snapshot.val().name;
              var placa = snapshot.val().vehiclePlate;
              this.nameDriver = nombre.toUpperCase();
              this.namePlate = placa.toUpperCase();
              this.markers.push({
                key: key,
                image: this.imageDriver,
                name: this.nameDriver,
                plate: this.namePlate,
                position: {
                  lat: location[0],
                  lng: location[1],
                },
              });
            });
          });

          query.on("key_exited", (key, location, distance) => {
            for (var i = 0; i < this.markers.length; i++) {
              if (this.markers[i].key == key) {
                this.markers.splice(i, 1);
              }
            }
          });
          queryWorking.on("key_exited", (key, location, distance) => {
            for (var i = 0; i < this.markers.length; i++) {
              if (this.markers[i].key == key) {
                this.markers.splice(i, 1);
              }
            }
          });

          query.on("key_moved", (key, location, distance) => {
            for (var i = 0; i < this.markers.length; i++) {
              if (this.markers[i].key == key) {
                var updatePosition = {
                  lat: location[0],
                  lng: location[1],
                };
                this.markers[i].position = updatePosition;
              }
            }
          });
          queryWorking.on("key_moved", (key, location, distance) => {
            for (var i = 0; i < this.markers.length; i++) {
              if (this.markers[i].key == key) {
                var updatePosition = {
                  lat: location[0],
                  lng: location[1],
                };
                this.markers[i].position = updatePosition;
              }
            }
          });
        });
      }
    },
    toggleInfoWindow: function (marker, idx) {
      this.infoWindowPos = marker["position"];
      this.infoContent = this.getInfoWindowContent(marker);
      //check if its the same marker that was selected if yes toggle
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      //if different marker set infowindow to open and reset current marker index
      else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },
    getInfoWindowContent: function (marker) {
      return `<div class="card">
                <div>
                    <img style="padding: 0px; margin: 0px; width: 80px; display: block; margin-left: auto; margin-right: auto;" src="${marker.image}" />
                    <p class="title" style="padding: 0px; margin: 0px;">${marker.name}</p>
                    <p class="title" style="padding: 0px; margin: 0px;">${marker.plate}</p>
                </div>
              </div>`;
    },
    onScroll(e) {
      this.offsetTop = e.target.scrollTop;
    },
    flyMarker(posicionLat, positionLng) {
      this.myCoordinates = {
        lat: posicionLat,
        lng: positionLng,
      };
      this.zoom = 17;
    },
    searchChanged() {
      let me = this;
      if (me.search) {
        geofireRef.get(me.search).then(function (location) {
          if (location === null) {
            console.log("no existe posición");
          } else {
            me.markers = [];
            const dataName = dbRefProveedor.child(me.search);
            dataName.once("value", (snapshot) => {
              if (snapshot.val().image) {
                me.imageDriver = snapshot.val().image;
              } else {
                me.imageDriver = require("../assets/logoAR.png");
              }
              me.nameDriver = snapshot.val().name;
              me.namePlate = snapshot.val().vehiclePlate;
              me.markers.push({
                key: me.search,
                image: me.imageDriver,
                name: me.nameDriver,
                plate: me.namePlate,
                position: {
                  lat: location[0],
                  lng: location[1],
                },
              });
            });
          }
        });
      } else {
        me.markers = [];
        me.initGeoFire();
      }
    },
  },
};
</script>
<style>
.positionbtn {
  position: absolute;
  top: 10px;
  left: 10px;
}
</style>